"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("./FormNav.css");
var _Home = _interopRequireDefault(require("@mui/icons-material/Home"));
var _West = _interopRequireDefault(require("@mui/icons-material/West"));
var _East = _interopRequireDefault(require("@mui/icons-material/East"));
var _react = require("react");
var _FlatButton = _interopRequireDefault(require("../FlatButton/FlatButton"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var FormNav = function FormNav(props) {
  var _props$theme, _props$theme2, _props$theme2$formNav, _props$theme3, _props$theme3$formNav, _props$theme4, _props$theme4$formNav, _props$theme5, _props$theme5$formNav, _props$theme6, _props$theme6$formNav;
  var _useState = (0, _react.useState)(props.currentStepIndex),
    _useState2 = _slicedToArray(_useState, 2),
    currentStepIndex = _useState2[0],
    setCurrentStepIndex = _useState2[1];
  var _useState3 = (0, _react.useState)(props.currentStep),
    _useState4 = _slicedToArray(_useState3, 2),
    currentStep = _useState4[0],
    setCurrentStep = _useState4[1];
  var _useState5 = (0, _react.useState)(props.totalSteps),
    _useState6 = _slicedToArray(_useState5, 2),
    totalSteps = _useState6[0],
    setTotalSteps = _useState6[1];
  var buttonFontSize = "15px";
  (0, _react.useEffect)(function () {
    setCurrentStepIndex(props.currentStepIndex);
    setCurrentStep(props.currentStep);
    setTotalSteps(props.totalSteps);
  }, [props.currentStepIndex, props.currentStep, props.totalSteps]);
  if (props.steps.length == 0) {
    return null;
  }
  function renderProgressIndicatorIfNeeded() {
    if (props.hideProgress) {
      return null;
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      id: "progress-indicator",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "form-nav-progress-bar",
        style: {
          width: currentStep / totalSteps * 100 + "%"
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "form-nav-progress-count",
        children: [currentStep, " / ", totalSteps]
      })]
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "form-nav",
    style: (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.formNav,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "form-nav-button",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FlatButton.default, {
        startIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Home.default, {}),
        variant: "contained",
        disableElevation: true,
        onClick: function onClick() {
          props.navigateToScreen(0);
        },
        sx: {
          padding: "5px 17px",
          fontSize: buttonFontSize,
          fontWeight: 400,
          borderRadius: "3px",
          color: ((_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : (_props$theme2$formNav = _props$theme2.formNav) === null || _props$theme2$formNav === void 0 ? void 0 : _props$theme2$formNav.color) || "black"
        },
        children: "Home"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "form-nav-button",
      children: currentStepIndex === 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_FlatButton.default, {
        startIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_West.default, {}),
        variant: "contained",
        disableElevation: true,
        disabled: true,
        className: "disabled",
        sx: {
          padding: "5px 17px",
          fontSize: buttonFontSize,
          fontWeight: 400,
          borderRadius: "3px 0 0 3px",
          marginRight: 0,
          color: ((_props$theme3 = props.theme) === null || _props$theme3 === void 0 ? void 0 : (_props$theme3$formNav = _props$theme3.formNav) === null || _props$theme3$formNav === void 0 ? void 0 : _props$theme3$formNav.color) || "black"
        },
        children: "Prev"
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_FlatButton.default, {
        startIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_West.default, {}),
        variant: "contained",
        disableElevation: true,
        sx: {
          padding: "5px 15px",
          fontSize: buttonFontSize,
          fontWeight: 400,
          borderRadius: "3px 0 0 3px",
          marginRight: 0,
          color: ((_props$theme4 = props.theme) === null || _props$theme4 === void 0 ? void 0 : (_props$theme4$formNav = _props$theme4.formNav) === null || _props$theme4$formNav === void 0 ? void 0 : _props$theme4$formNav.color) || "black"
        },
        onClick: function onClick() {
          props.navigateToScreen(currentStepIndex - 1);
        },
        children: "Prev"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "form-nav-button",
      children: currentStepIndex >= props.steps.length ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_FlatButton.default, {
        endIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_East.default, {}),
        variant: "contained",
        disableElevation: true,
        disabled: true,
        className: "disabled",
        sx: {
          padding: "5px 17px",
          fontSize: buttonFontSize,
          fontWeight: 400,
          marginLeft: -1,
          borderLeft: "1px solid #7E7E7E",
          borderRadius: "0 3px 3px 0",
          color: ((_props$theme5 = props.theme) === null || _props$theme5 === void 0 ? void 0 : (_props$theme5$formNav = _props$theme5.formNav) === null || _props$theme5$formNav === void 0 ? void 0 : _props$theme5$formNav.color) || "black"
        },
        children: "Next"
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_FlatButton.default, {
        endIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_East.default, {}),
        variant: "contained",
        disableElevation: true,
        sx: {
          padding: "5px 17px",
          fontSize: buttonFontSize,
          fontWeight: 400,
          borderRadius: "0 3px 3px 0",
          marginLeft: -1,
          borderLeft: "1px solid #7E7E7E",
          color: ((_props$theme6 = props.theme) === null || _props$theme6 === void 0 ? void 0 : (_props$theme6$formNav = _props$theme6.formNav) === null || _props$theme6$formNav === void 0 ? void 0 : _props$theme6$formNav.color) || "black"
        },
        onClick: function onClick() {
          props.navigateToScreen(currentStepIndex + 1);
        },
        children: "Next"
      })
    }), renderProgressIndicatorIfNeeded()]
  });
};
var _default = FormNav;
exports.default = _default;